// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"148":"2d1323883846eae720b6","424":"6b6f7a843f596c7a1289","522":"1a80134d6b10d1bc4824","795":"cfe0c8689c1c40646ca8"}[chunkId] + ".chunk.js";
};